<template>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="推荐门店积分" :style="'margin-bottom:'+(form.is_invitation_point?'0px':'20px') ">
        <!-- <a-radio-group v-model:value="form.is_invitation_point">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="0">关闭</a-radio>
        </a-radio-group> -->
        <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_invitation_point" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 20, offset: 4 }" name='invitation_point' class="m-t-10" v-if='form.is_invitation_point'>
        <span class="m-r-10">成功推荐一家门店，获得</span>
        <a-input-number v-model:value="form.invitation_point" style="width: 100px;" placeholder='请输入' :min='1' :precision='0' />
        <span class="m-l-10">积分</span>
      </a-form-item>
      <a-form-item label="返单奖励积分" :style="'margin-bottom:'+(form.is_rebate_point?'0px':'20px') ">
        <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_rebate_point" />
        <span style="color:#999;margin-left:10px">(需开通智能防窜应用才能生效)</span>
      </a-form-item>
      <!--  -->
       <a-form-item :wrapper-col="{ span: 20, offset: 4 }" style="margin-bottom:10px;margin-top:10px" v-if='form.is_rebate_point'>
          <a-radio-group v-model:value="form.is_fixed">
            <a-radio :value="1">奖励固定积分</a-radio>
            <a-radio :value="2">按商品价格比例奖励</a-radio>
          </a-radio-group>
       </a-form-item>
       <!-- 积分 -->
      <a-form-item :wrapper-col="{ span: 20, offset: 4 }" name='rebate_point' v-if='form.is_rebate_point' v-show="form.is_fixed==1">
        <span class="m-r-10">被推荐门店使用智能防窜成功签收一个商品，推荐人门店获得</span>
        <a-input-number v-model:value="form.rebate_point" style="width: 100px;" placeholder='请输入' :min='1' :precision='0' />
        <span class="m-l-10">积分</span>
      </a-form-item>
      <!-- 比例 -->
      <a-form-item :wrapper-col="{ span: 20, offset: 4 }" name='rebate_point_percentage' v-if='form.is_rebate_point' v-show="form.is_fixed==2">
        <span class="m-r-10">被推荐门店使用智能防窜成功签收一个商品，推荐人门店获得商品价格</span>
        <a-input-number v-model:value="form.rebate_point_percentage" style="width: 100px;" placeholder='请输入' :max="100" :min="0" :precision='2' />
        <span class="m-l-10 m-r-5">%的等价积分</span>
        <a-tooltip placement="right" :overlayStyle="{'maxWidth':'460px'}">
              <template #title>
                <div style="width:460px;padding-left:5px">
                   <span >获得积分公式：商品价格*积分金额比率*奖励百分比。</span><br/>
                   <span class="p-l-10">1.商品价格按产品库-产品列表中的商品价格计算。</span><br/>
                   <span class="p-l-10">2.积分金额比率：在“资产-积分-积分设置-积分“抵扣”规则”中设置。</span><br/>
                   <span class="p-l-10">3.奖励百分比：当前弹窗设置的奖励百分比。</span><br/>
                   <span class="p-l-10 ">4.奖励积分采取四舍五入取整的方式发放。</span><br/>
                </div>
              </template>
             <ExclamationCircleOutlined style="color:#999"/>
           </a-tooltip>
      </a-form-item>
      <!-- 下单 -->
       <a-form-item label="下单奖励积分" :style="'margin-bottom:'+(form.is_order_point?'0px':'30px') ">
        <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_order_point" />
        <span style="color:#999;margin-left:10px">(需开通直播云店应用才能生效，隔天发放奖励)</span>
       </a-form-item>
       
      
      <!--  -->
      <a-form-item :wrapper-col="{ span: 20, offset:4 }" v-if="form.is_order_point" style="margin-bottom:10px">
        <div class="m-t-10">消费者在被推荐门店的云店中下单且确认收货后，推荐人门店可获得积分</div>
        <!-- 订单计算方式"-->
       <a-form-item label="订单计算积分"  name='' class="m-t-15" style="margin-bottom:15px">
         <a-radio-group v-model:value="form.order_compute_mode">
          <a-radio :value="1">按实际支付金额计算</a-radio>
          <a-radio :value="2">按优惠前金额计算</a-radio>
        </a-radio-group>
      </a-form-item>
         <a-form-item label="下单规则"  name="order_rule_money" style="margin-bottom:15px">
            <span>订单金额大于等于</span>
             <a-input-number v-model:value="form.order_rule_money" style="width: 100px;margin:0 10px;" placeholder='请输入' :min="1" :precision='2' />
            <span>元，触发奖励积分</span>
         </a-form-item>
          <a-form-item label="奖励规则"   style="margin-bottom:15px">
         <a-radio-group v-model:value="form.order_reward">
          <a-radio :value="1">固定积分值</a-radio>
          <a-radio :value="2">订单百分比换算</a-radio>
        </a-radio-group>
        </a-form-item>
        <!-- 积分 -->
         <a-form-item label=""  v-if="form.order_reward==1" name="order_point">
           <span><span style="color:#ff4d4f" class="m-r-5">*</span>推荐人门店获得</span>
            <a-input-number v-model:value="form.order_point" style="width: 100px;margin:0 10px;" placeholder='请输入'  :min="1" :precision='0' />
            <span>积分</span>
        </a-form-item>
        <!-- 比例 -->
         <a-form-item  v-if="form.order_reward==2" name="order_point_percentage">
           <span><span style="color:#ff4d4f" class="m-r-5">*</span>推荐人门店订单金额的</span>
            <a-input-number v-model:value="form.order_point_percentage" style="width: 100px;margin:0 10px;" placeholder='请输入' :max="100" :min="0" :precision='2' />
            <span class="m-r-5">%的等价积分</span>
             <a-tooltip placement="right" :overlayStyle="{'maxWidth':'460px'}">
                <template #title>
                  <div style="width:460px;">
                     <span >获得积分公式：订单金额*积分金额比率*订单金额百分比。</span><br/>
                     <span class="p-l-10">1.订单金额按订单计算方式中设置的计算方式获取。</span><br/>
                     <span class="p-l-10">2.积分金额比率：在“资产-积分-积分设置-积分“抵扣”规则”中设置。</span><br/>
                     <span class="p-l-10">3.订单金额百分比：当前弹窗设置的推荐人门店订单金额百分比。</span><br/>
                     <span class="p-l-10 ">4.奖励积分采取四舍五入取整的方式发放。</span><br/>
                  </div>
                </template>
               <ExclamationCircleOutlined style="color:#999"/>
           </a-tooltip>
      </a-form-item>
      </a-form-item>
       
      <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
        <a-button type="primary" @click="onSubmit">确定</a-button>
      </a-form-item>
    </a-form>
</template>
<script>
 import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { setStoreRebate } from "@/api/store";
  import { iscode } from "@/utils/app";
  let defForm = {
    level: '',
    is_invitation_point:1,
    invitation_point:1,
    is_rebate_point:1,
    rebate_point:1,
    is_fixed:1,
    rebate_point_percentage:0,
    is_order_point:1,
    order_compute_mode:1,
    order_rule_money:1,
    order_reward:1,
    order_point:1,
    order_point_percentage:0
  };
  export default {
    props: {
      formData: {
        type: Object
      }
    },
    components: { ExclamationCircleOutlined },
    name: 'editForm',
    setup(props, { emit }) {
      const form = ref({ ...defForm });
      const validator = async (rule, value) =>{
           if(form.value.is_rebate_point==1&&form.value.is_fixed==2){
                if(!value){
                   return Promise.reject('请选输入返单价格比例奖励');
                }
           }else{
             return Promise.resolve();
           }
      }
      const state = reactive({
        labelCol: {span: 4},
        wrapperCol: {span: 20,offset:0},
        rules: {
          invitation_point: [
            { required: true, message: '请输入推荐门店积分'}
          ],
          rebate_point:[
            {required: true, message: '请选输入返单奖励积分'}
          ],
          rebate_point_percentage:[
            // {required: true, message: '请选输入返单奖励积分'}
            {
              required: true,
              validator:validator
            }
          ],
          order_rule_money:[ { required: true, message: '请输入下单规则'}],
          order_point:[{
            required: true,
            validator:async (rule, value) =>{
                 if(form.value.is_order_point&&form.value.order_reward==1){
                    if(!value){
                       return Promise.reject('请选输入下单奖励积分');
                    }
               }else{
                 return Promise.resolve();
               }
            }
          }],
           order_point_percentage:[{
            required: true,
            validator:async (rule, value) =>{
                 if(form.value.is_order_point&&form.value.order_reward==2){
                    if(!value){
                       return Promise.reject('请选输入下单奖励价格比例积分(大于0)');
                    }
               }else{
                 return Promise.resolve();
               }
            }
          }]
        }
      });
      const ruleForm = ref();
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading("正在加载中...", 0);
          form.value.is_invitation_point = +form.value.is_invitation_point;
          form.value.is_order_point = +form.value.is_order_point;
          form.value.is_rebate_point = +form.value.is_rebate_point;
          let res = await setStoreRebate({...form.value}).then((res) => res.data).catch(error => error);
          if (iscode(res)) {
            emit("onsubmit");
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        }).catch((error) => {
          message.error("请完善表单！");
        });
      }
      //数字判断
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      onMounted(() => {
        form.value = JSON.parse(JSON.stringify(props.formData));
        form.value.invitation_point = !isNumber(form.value.invitation_point) ? null : form.value.invitation_point;
        form.value.rebate_point = !isNumber(form.value.rebate_point) ? null : form.value.rebate_point;
        console.log(form.value.rebate_point)
        form.value.is_rebate_point = !!form.value.is_rebate_point;
        form.value.is_invitation_point = !!form.value.is_invitation_point;
        form.value.is_order_point = !!form.value.is_order_point;
        form.value.order_compute_mode = +form.value.order_compute_mode;
        form.value.order_reward = +form.value.order_reward;
      });
      return {
        ...toRefs(state),
        form,
        onSubmit,
        ruleForm
      };
    },
  };
</script>

<style lang="less" scoped>
.ant-switch-checked{
   background: #178dfa;
}

</style>